Feedback = {

    options: {

        debug: false,

        with_ajax: true
    },

    /**
     * The url the form will post to
     */
    post: '',

    FormValidation: function () {

        var self = this,
            form = $('#feedback_form');

        /**
         * http://jqueryvalidation.org/validate/
         */
        validator = form.validate({

            rules: {
                name: {
                    required: true
                },

                email: {
                    required: true
                    , email: true
                },
                comment: {
                    required: true
                }
            },

            messages: {
                name: {
                    required: "Пожалуйста, укажите Ваше имя."
                },
                email: {
                    required: "Пожалуйста, укажите Ваш email."
                },
                comment: {
                    required: "Пожалуйста, укажите текст сообщения."
                }
            },

            /**
             * this handler is passed the form element
             */
            submitHandler: function (form) {
                //form.submit(); // submit the form
                self.sendFormDataToServer(form);
                return false; // prevent form submit
            }
        });
    },

    /**
     * Makes an ajax call
     *
     * @param form
     */
    sendFormDataToServer: function(form) {

        var self = this,
            form = $(form),
            error_msg_el = $('#error_message'),
            success_msg_el = $('#success_message');

        error_msg_el.hide().empty();
        success_msg_el.hide().empty();

        var params = form.serialize();

        if(self.options.debug) {
            console.log('params:');
            console.log(params);
        }

        var url = self.post;

        if(self.options.debug) {
            console.log('url:');
            console.log(url);
        }

        var jqXHR = $.ajax({
            method: 'post',
            url: url,
            data: params
        });

        jqXHR.success(function (data, textStatus, jqXHR) {

            if(data.result === 'error') {
                error_msg_el.show().text(data.msg);
            } else {
                success_msg_el.show().text(data.msg);
            }

        });

        jqXHR.error(function (jqXHR, textStatus, errorThrown) {
            error_msg_el.show().text('Извините, произошла ошибка при отправке Вашего запроса. Пожалуйста, сообщите нам об этом по телефону!');
            console.log('Error sending request: '+ textStatus +", "+errorThrown);
            console.log(textStatus);
            console.log(errorThrown);
            //console.log(jqXHR);
        });

        jqXHR.done(function (data, textStatus, jqXHR) {

        });
    }
};


